import Eyebrow from "../../Eyebrow";
import Reveal from "../../Reveal";
import SpotlightCard from "../../SpotlightCard";
import TechNote from "../TechNote";
import { howItWorksSections } from "../../../../content/howItWorksSections";

const StormViz = () => (
  <svg viewBox="0 0 360 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="28" r="5" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.45)" strokeWidth="1" />
    <circle cx="18" cy="50" r="5" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.45)" strokeWidth="1" />
    <circle cx="18" cy="72" r="5" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.45)" strokeWidth="1" />
    <text x="28" y="32" fill="rgba(255,255,255,0.68)" fontSize="8" fontFamily="Public Sans, sans-serif">Web</text>
    <text x="28" y="54" fill="rgba(255,255,255,0.68)" fontSize="8" fontFamily="Public Sans, sans-serif">CVEs</text>
    <text x="28" y="76" fill="rgba(255,255,255,0.68)" fontSize="8" fontFamily="Public Sans, sans-serif">Domain</text>

    <line x1="23" y1="28" x2="142" y2="50" stroke="rgba(96,165,250,0.55)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" />
    </line>
    <line x1="23" y1="50" x2="142" y2="50" stroke="rgba(96,165,250,0.55)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" begin="0.6s" />
    </line>
    <line x1="23" y1="72" x2="142" y2="50" stroke="rgba(96,165,250,0.55)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" begin="1.2s" />
    </line>

    <circle cx="180" cy="50" r="38" fill="none" stroke="rgba(59,130,246,0.18)" strokeWidth="1.5">
      <animate attributeName="r" values="38;54;38" dur="4s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.6;0;0.6" dur="4s" repeatCount="indefinite" />
    </circle>
    <circle cx="180" cy="50" r="38" fill="rgba(59,130,246,0.07)" stroke="rgba(59,130,246,0.42)" strokeWidth="1.2" />
    <text x="180" y="47" textAnchor="middle" fill="rgba(255,255,255,0.88)" fontSize="9" fontFamily="Public Sans, sans-serif" fontWeight="300" letterSpacing="0.1em">STORM</text>
    <text x="180" y="60" textAnchor="middle" fill="rgba(96,165,250,0.62)" fontSize="7" fontFamily="Public Sans, sans-serif" fontWeight="300" letterSpacing="0.06em">CITED</text>

    <line x1="218" y1="50" x2="305" y2="50" stroke="rgba(96,165,250,0.55)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" />
    </line>

    <circle cx="310" cy="50" r="6" fill="rgba(59,130,246,0.15)" stroke="rgba(96,165,250,0.7)" strokeWidth="1">
      <animate attributeName="opacity" values="1;0.3;1" dur="2.4s" begin="0s" repeatCount="indefinite" />
    </circle>
    <text x="322" y="47" fill="rgba(96,165,250,0.88)" fontSize="8" fontFamily="Public Sans, sans-serif" fontWeight="300">Cited</text>
    <text x="322" y="58" fill="rgba(96,165,250,0.88)" fontSize="8" fontFamily="Public Sans, sans-serif" fontWeight="300">Report</text>
  </svg>
);

/**
 * Deliberately distinct from StormViz's converge-to-a-hub shape: one dashed
 * "template" block replicated directly into three solid, realized instances —
 * a copy/stamp motif rather than a synthesis motif.
 */
const SwarmKitViz = () => (
  <svg viewBox="0 0 360 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14" y="34" width="34" height="34" rx="4" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2" strokeDasharray="3 3" />
    <text x="31" y="55" textAnchor="middle" fill="rgba(255,255,255,0.8)" fontSize="9" fontFamily="Public Sans, sans-serif" fontWeight="300">TPL</text>
    <text x="31" y="82" textAnchor="middle" fill="rgba(255,255,255,0.55)" fontSize="8" fontFamily="Public Sans, sans-serif" letterSpacing="0.04em">Template</text>

    <line x1="50" y1="42" x2="278" y2="22" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" />
    </line>
    <line x1="50" y1="50" x2="278" y2="50" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" begin="0.5s" />
    </line>
    <line x1="50" y1="58" x2="278" y2="78" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" strokeDasharray="3 5">
      <animate attributeName="stroke-dashoffset" from="0" to="-8" dur="1.8s" repeatCount="indefinite" begin="1s" />
    </line>

    <rect x="278" y="12" width="20" height="20" rx="3" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2">
      <animate attributeName="opacity" values="0.4;1;0.4" dur="2.4s" begin="0s" repeatCount="indefinite" />
    </rect>
    <rect x="278" y="40" width="20" height="20" rx="3" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2">
      <animate attributeName="opacity" values="0.4;1;0.4" dur="2.4s" begin="0.8s" repeatCount="indefinite" />
    </rect>
    <rect x="278" y="68" width="20" height="20" rx="3" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2">
      <animate attributeName="opacity" values="0.4;1;0.4" dur="2.4s" begin="1.6s" repeatCount="indefinite" />
    </rect>
    <text x="304" y="26" fill="rgba(255,255,255,0.8)" fontSize="8" fontFamily="Public Sans, sans-serif" fontWeight="300">Security</text>
    <text x="304" y="54" fill="rgba(255,255,255,0.8)" fontSize="8" fontFamily="Public Sans, sans-serif" fontWeight="300">CI/CD</text>
    <text x="304" y="82" fill="rgba(255,255,255,0.8)" fontSize="8" fontFamily="Public Sans, sans-serif" fontWeight="300">Custom</text>
  </svg>
);

const vizComponents = { storm: StormViz, swarmkit: SwarmKitViz };

/**
 * Two supplementary platform capabilities: on-demand research/reporting and
 * the reusable swarm template used to build new specialists.
 * Translation: Two supplementary platform capabilities: on-demand research/reporting and
 * the reusable swarm template used to build new specialists.
 *
 * @returns {JSX.Element} Platform notes section.
 */
const PlatformNotes = () => {
  const { platformNotes, techNotes } = howItWorksSections;

  return (
    <section id="platform-notes" className="section-block">
      <div className="section-shell">
        <Reveal>
          <Eyebrow>
            {platformNotes.eyebrowLabel}
            <TechNote>{techNotes[platformNotes.techNote]}</TechNote>
          </Eyebrow>
          <h2 className="section-heading__title">{platformNotes.title}</h2>
          <p className="section-heading__intro">{platformNotes.description}</p>
        </Reveal>

        <div className="hiw-platform-notes">
          {platformNotes.cards.map((card) => {
            const Viz = vizComponents[card.viz];
            return (
              <Reveal key={card.title}>
                <SpotlightCard className="glass-panel hiw-platform-card">
                  <Eyebrow>
                    {card.label}
                    <TechNote>{techNotes[card.techNote]}</TechNote>
                  </Eyebrow>
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                  <div className="kanzi-how-viz" aria-hidden="true">
                    <Viz />
                  </div>
                  {card.detail && <p className="hiw-detail-text">{card.detail}</p>}
                </SpotlightCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PlatformNotes;
